// @ts-expect-error untyped
import UIDragListHandle from 'ui-addon-draggable/draggable/UIDragListHandle';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DragListHandle({
  children,
  className,
  style
}) {
  if (children === undefined) {
    return /*#__PURE__*/_jsx(UIDragListHandle, {
      className: className,
      style: style,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(DragHandle, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(UIDragListHandle, {
    className: className,
    style: style,
    children: children
  });
}